$(function () {
  $('.quantity').each(function () {
    var input = $('.quantity-input', this),
        up = $('.quantity-up', this),
        down = $('.quantity-down', this);

    down.click(function () {
      if (input.val() < 99) {
        input.val(+input.val() + 1);
      }
      return false;
    });

    up.click(function () {
      if (input.val() > 1) {
        input.val(+input.val() - 1);
      }
      return false;
    });
  });

  $('#productVariant').change(function () {
    var selectedVariantId = $(this).val();
    if (variantsData[selectedVariantId]) {
      $('.product__price').text(variantsData[selectedVariantId].price);
    }
  });
});
